var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_713_128218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4998 2H13.4999C12.5717 2 11.6815 2.36876 11.0251 3.02515C10.3688 3.68146 10.0001 4.57169 10.0001 5.49992V6.99991C11.1932 7.00124 12.337 7.47568 13.1806 8.31935C14.0243 9.16294 14.4988 10.3068 14.5001 11.4999V13.9999H17.5L19.9024 16.4023H19.9025C19.9681 16.4679 20.0571 16.5048 20.15 16.5048C20.2428 16.5048 20.3318 16.4679 20.3974 16.4023C20.4631 16.3366 20.5 16.2477 20.5 16.1548V13.9998C21.4283 13.9998 22.3185 13.631 22.975 12.9746C23.6313 12.3183 24 11.4281 24 10.4999V5.49992C24 4.57165 23.6313 3.68142 22.975 3.02515C22.3186 2.36876 21.4283 2 20.5 2H20.4998Z",
    fill: "#D5DAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 19.5H5.99991L3.59734 21.9026C3.53172 21.9682 3.44273 22.0051 3.34984 22.0051C3.25703 22.0051 3.16805 21.9683 3.10234 21.9026C3.03672 21.837 2.99985 21.748 2.99985 21.6552L2.99977 19.5C2.20416 19.5 1.4411 19.184 0.878591 18.6214C0.316017 18.0588 0 17.2958 0 16.5002V11.4999C0 10.7044 0.316017 9.94131 0.878591 9.37871C1.44116 8.81614 2.2042 8.50012 2.99977 8.50012H10.0001C10.7956 8.50012 11.5587 8.81614 12.1213 9.37871C12.6838 9.94129 12.9999 10.7043 12.9999 11.4999V16.5002C12.9999 17.2958 12.6838 18.0588 12.1213 18.6214C11.5587 19.184 10.7957 19.5 10.0001 19.5L10.0001 19.5Z",
    fill: "#D5DAE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_713_128218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.23e30ab37977a78795930bd27df5392e.svg";
export { ForwardRef as ReactComponent };